import React from 'react';
import {Modal, View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import {ModernCloseIcon} from '~assets/icons';
import {useTheme} from '~contexts/ThemeContext';

interface IssueModalProps {
  visible: boolean;
  onClose: () => void;
  onTechnicalIssueClick: () => void;
  onEventIssueClick: () => void;
}

const IssueModal: React.FC<IssueModalProps> = ({visible, onClose, onTechnicalIssueClick, onEventIssueClick}) => {
  const {colors} = useTheme();
  const dynamicStyles = createStyles(colors);
  return (
    <Modal transparent visible={visible} animationType="fade">
      <View style={dynamicStyles.overlay}>
        <View style={dynamicStyles.modalContainer}>
          {/* Modern Close Icon in Top-Right Corner */}
          <TouchableOpacity onPress={onClose} style={dynamicStyles.closeIcon}>
            <ModernCloseIcon size={20} variant="minimal" />
          </TouchableOpacity>

          <Text style={dynamicStyles.title}>Need Assistance?</Text>
          <Text style={dynamicStyles.message}>Is your question related to a technical issue or an event-related concern?</Text>

          <View style={dynamicStyles.buttonContainer}>
            <TouchableOpacity style={dynamicStyles.button} onPress={onTechnicalIssueClick}>
              <Text style={dynamicStyles.buttonText}>Technical Issue</Text>
            </TouchableOpacity>
            <TouchableOpacity style={dynamicStyles.button} onPress={onEventIssueClick}>
              <Text style={dynamicStyles.buttonText}>Event Issue</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 30,
    margin: 20,
    maxWidth: 350,
    width: '90%',
    position: 'relative',
  },
  closeIcon: {
    position: 'absolute',
    top: 15,
    right: 15,
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: '#f0f0f0',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 15,
    color: '#333',
    marginTop: 10,
  },
  message: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 25,
    color: '#666',
    lineHeight: 22,
  },
  buttonContainer: {
    flexDirection: 'column',
    gap: 12,
  },
  button: {
    backgroundColor: '#007AFF',
    paddingVertical: 15,
    paddingHorizontal: 20,
    borderRadius: 12,
    alignItems: 'center',
  },
  buttonText: {
    color: '#fff',
    fontWeight: '600',
  },
});

const createStyles = (colors: any) =>
  StyleSheet.create({
    overlay: {
      flex: 1,
      backgroundColor: colors.overlayBackground,
      justifyContent: 'center',
      alignItems: 'center',
    },
    modalContainer: {
      backgroundColor: colors.surface,
      borderRadius: 20,
      padding: 30,
      margin: 20,
      maxWidth: 350,
      width: '90%',
      position: 'relative',
    },
    closeIcon: {
      position: 'absolute',
      top: 15,
      right: 15,
      width: 30,
      height: 30,
      borderRadius: 15,
      backgroundColor: colors.gray100,
      justifyContent: 'center',
      alignItems: 'center',
    },
    title: {
      fontSize: 20,
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: 15,
      color: colors.textPrimary,
      marginTop: 10,
    },
    message: {
      fontSize: 16,
      textAlign: 'center',
      marginBottom: 25,
      color: colors.textSecondary,
      lineHeight: 22,
    },
    buttonContainer: {
      flexDirection: 'column',
      gap: 12,
    },
    button: {
      backgroundColor: colors.info,
      paddingVertical: 15,
      paddingHorizontal: 20,
      borderRadius: 12,
      alignItems: 'center',
    },
    buttonText: {
      color: colors.white,
      fontWeight: '600',
    },
  });

export default IssueModal;
